<template>
	<div class="template-carousel">
		<header class="header">
			<h1 class="title">{{ translate("heading") }}</h1>
			<CloseButton
				size="SMALL"
				type="TERTIARY"
				@click="$emit( `close` )"
			/>
		</header>
		<main class="body">
			<CarouselTemplate
				v-for="template in patchedTemplates"
				:key="template.meetingTemplateId"
				:template="template"
				v-on="bubble( `applyTemplate`, `previewTemplate`, `deleteTemplate` )"
			/>
		</main>
	</div>
</template>

<script>
import {
	EventsMixin,
	CloseButton
} from "@teaming/common-ui";

import CarouselTemplate from "./CarouselTemplate.vue";
export default {
	name: "TemplateCarousel",
	mixins: [ EventsMixin, ],
	emits: [
		"applyTemplate",
		"previewTemplate",
		"deleteTemplate",
	],
	components: {
		CarouselTemplate,
		CloseButton,
	},
	props: {
		templates: {
			type: Array,
			required: true,
		},
	},
	computed: {
		patchedTemplates() {
			return this.templates.map( template => {
				return {
					...template,
					// disable delete functionality to prevent possible
					// confusion (users may think they are just removing
					// a template from the recommendations, rather than
					// outright deleting it)
					canDelete: false,
				};
			} );
		},
	},
	methods: {
		translate( key, args = {} ) {
			const { name, } = this.$options;
			return this.$t( `common-team.components.${ name }.${ key }`, args );
		},
	},
};
</script>

<style lang="scss" scoped>
$titleColor: $color1-700;
$backgroundColor: $color1-050;

.template-carousel {
	display: flex;
	flex-direction: column;
	gap: 1.125rem;

	position: relative;
	padding: 1rem;
	border-radius: 0.5rem;
	background-color: $backgroundColor;
}

.template-carousel .header {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}

.template-carousel .title {
	@include font-and-line-for(0);
	font-weight: 600;
	color: $titleColor;
}

.template-carousel .body {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	gap: 1rem;

	@include auto-x-scroll();
	position: relative;
}
</style>

<style lang="scss">
.template-carousel .carousel-template {
	width: 14rem; // 224px

	@include for-size('md') {
		width: 21.333125rem; // 341.33px
	}

}
</style>
